/* Regra única de idade esperada por série/turma — apenas SINALIZA, nunca bloqueia. */

const norm = (s) => String(s || "")
  .normalize("NFKD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[ºª°]/g, "")
  .toLowerCase()
  .replace(/(\d)\s*[oa](?![a-z])/g, "$1");

/** Idade esperada (aproximada, em 31/03 do ano letivo) para uma série ou nome de turma. */
export function expectedAgeForSeries(label) {
  const s = norm(label);
  if (!s) return null;
  if (s.includes("jardim")) return /(\bii\b|\b2\b)/.test(s) ? 5 : 4;
  if (s.includes("medio") || /\be\.?\s*m\b/.test(s) || /\bem\b/.test(s)) {
    const m = s.match(/([1-3])\s*(?:ano|serie)?/);
    return m ? 14 + Number(m[1]) : null;
  }
  const m = s.match(/([1-9])\s*(?:ano|serie)/);
  return m ? 5 + Number(m[1]) : null;
}

/** Idade atual (anos completos) a partir de uma data ISO yyyy-mm-dd. */
export function ageFromISO(iso) {
  const s = String(iso || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null;
  const b = new Date(`${s}T00:00:00`);
  const now = new Date();
  let a = now.getFullYear() - b.getFullYear();
  const m = now.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < b.getDate())) a -= 1;
  return a < 0 ? null : a;
}

export const fmtBR = (iso) => {
  const s = String(iso || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return "—";
  const [y, m, d] = s.split("-");
  return `${d}/${m}/${y}`;
};

/**
 * Aviso de conferência: idade × série. Tolerância de ±1 ano.
 * @returns {null | { level: 'info'|'warn', message: string }}
 */
export function seriesAgeCheck({ birthDate, seriesLabel, targetYear }) {
  const iso = String(birthDate || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
    return { level: "info", message: "Nascimento não informado — confira" };
  }
  const expected = expectedAgeForSeries(seriesLabel);
  const year = Number(targetYear) || new Date().getFullYear();
  if (!expected) return null;
  const ageAtYear = year - Number(iso.slice(0, 4));
  if (Math.abs(ageAtYear - expected) <= 1) return null;
  return {
    level: "warn",
    message: `Idade ${ageAtYear} em ${year} · esperado ~${expected} para ${seriesLabel} — confira antes de efetivar`,
  };
}
